exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-criteria .search-checkboxes[data-v-26deb30c]{margin-top:0}", ""]);

// exports
